import { Unique } from "../../../../shared/scripts/array-functions";
import { IFilter, InitializeFilterDropdown } from "../../../../shared/scripts/filtering";
import { getData } from "./site.utilities";

export class CTMSSiteContactsSection implements IFilter {

    items: any[];
    itemsTable: any;
    tableSelector = '#contactsTable';
    searchSelector = '#contacts-search';
    clearSelector = '#contacts-search-clear';

    url: string;

    constructor(handlerUrl: string){
        this.url = handlerUrl;

        this.initialize();
    }

    initialize() {
        this.itemsTable = $(this.tableSelector).DataTable({
            "dom": 'lrtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '200px',
            scrollCollapse: true,
            orderCellsTop: true,
            columns: [
                // { data:'FirstName', title: 'First Name', className: '' },
                // { data:'LastName', title: 'Last Name', className: '' },
                { data:'ContactName', title: 'Name', className: '' },
                { data:'Email', title: 'Email', className: '' },
                { data: "StudyNameAndRole", title: "Study (Role)", render: (data) => Array.isArray(data) ? data.slice().sort().join(", ") : data },
                { data:'PhoneNumber', title: 'Phone', className: '' },
                {
                    data: null,
                    title: "",
                    className: "ctms-table-col-actions",
                    orderable: false,
                    render: function (data, type, row) {
                        return `<button title="Edit"><i class="ctms-icon-pencil"></i></button>`;
                    }
                },
            ]
        });

        InitializeFilterDropdown('#contacts-study', [], this);

        $(this.searchSelector).on('input', (evt) => {
            $(this.tableSelector).DataTable().search(String($(evt.target).val() ?? '')).draw();
        });
        $(this.clearSelector).on('click', (evt) => {
            $(this.searchSelector).val('');
            $(this.tableSelector).DataTable().search('').draw();
        });

    }

    async loadData() {
        $('#contactsSectionLoading').removeClass('d-none');

        this.items = await getData(this.url);

        this.itemsTable.clear();
        this.itemsTable.rows.add(this.items).draw();

        const studyValues = Unique(this.items.map(c => c.StudyNames).flat(), true).sort();
        $('#contacts-study').empty();
        $('#contacts-study').append(studyValues.map(e => new Option(e, e, false, true)));
        $('#contacts-study').selectpicker("refresh");

        $('#contactsSectionLoading').addClass('d-none');
    }

    triggerFilter() {
        const study = $('#contacts-study').val() as [any];

        const filteredItems = this.items.filter((c) => {
            return study.some(s => c.StudyNames.includes(s));
        });

        this.itemsTable.clear();
        this.itemsTable.rows.add(filteredItems).draw();
    }
}